import React, { Component } from 'react';
import _ from 'lodash';
import './Improving.css';
import ImprovingTabs from './ImprovingTabs/ImprovingTabs';

class Improving extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            advantage: [],
            createdData: false,
            editedData: true,
            competeData: [],
            tabs: [],

            oldData: [],
            competitorsGroupsData: [],
            benefitsData: [],
            countCCWT: [],
            totalScore: '',
        };
    }

    componentWillMount() {
        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }

        let advantageData = {
            projectId: this.props.projectId,
            type: 'advantage'
        }

        let challengeData = {
            type: "challenge",
            projectId: this.props.projectId,
        }

        let competitorsData = {
            projectId: this.props.projectId,
            type: 'competitors'
        }


        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getDifferentialAdvantage(advantageData);

        this.props.getChallengeStatements(challengeData);
        this.props.getCompetitorsGroups(competitorsData);
    }

    onNewItemAdd = (groupId, segmentId, data, type) => {

        let advantage = [...this.state.advantage];
        let existItem = advantage.find(r => r.groupId === groupId && r.segmentId === segmentId);

        if (existItem) {
            existItem[type].push({
                name: data.name,
                id: data.id
            })
        } else if (!existItem) {
            advantage.push({
                focus: [],
                rules: [],
                tactics: [],
                groupId: groupId,
                segmentId: segmentId,
            })

            let exist = advantage.find(r => r.groupId === groupId && r.segmentId === segmentId);
            if (exist) {
                exist[type].push({
                    name: data.name,
                    id: data.id
                })
            }
        }

        this.setState({ advantage })
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.compete.competeData.Items && _.isEmpty(this.state.competeData)) {
            if (!nextProps.compete.competeFetching && !_.isEmpty(nextProps.compete.competeData.Items) && !_.isEmpty(nextProps.compete.customerSegmentData)) {
                let tabs = [...this.state.tabs];
                nextProps.compete.competeData.Items[0].dataBenefits.map(item => {
                    let customerSegmentItem = nextProps.compete.customerSegmentData.find(r => r.groupId === item.groupId);
                    let segmentData = customerSegmentItem.segments.find(r => r.segmentId === item.segmentId);
                    tabs.push({
                        groupId: item.groupId,
                        groupName: customerSegmentItem.groupName,
                        segmentId: item.segmentId,
                        segmentName: segmentData.name
                    });
                });
                this.setState({
                    competeData: nextProps.compete.competeData.Items[0].dataBenefits,
                    tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
                });
            }

            if (_.isEmpty(nextProps.compete.competeData.Items) && !this.state.createdData) {

                this.setState({ createdData: true, editedData: false })
            }
        }

        if (nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items && _.isEmpty(this.state.advantage)) {
            if (!nextProps.differentialAdvantageData.getDifferentialAdvantageFetching && !_.isEmpty(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items)) {
                let advantage = [...this.state.advantage]
                nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].advantage.map(item => {
                    advantage.push({
                        focus: item.focus,
                        groupId: item.groupId,
                        rules: item.rules,
                        segmentId: item.segmentId,
                        tactics: item.tactics
                    });
                });
                this.setState({
                    editedData: true,
                    createdData: false,
                    advantage: _.uniqBy(advantage, v => [v.groupId, v.segmentId].join())
                });
            }

            if (!nextProps.differentialAdvantageData.getDifferentialAdvantageFetching && _.isEmpty(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items)) {
                this.setState({
                    editedData: false,
                    createdData: true,
                });
            }

        }

        if (nextProps.compete.benefitsData && !_.isEmpty(nextProps.compete.benefitsData) && _.isEmpty(this.state.benefitsData)) {
            let benefitsData = [...this.state.benefitsData]
            nextProps.compete.benefitsData.res.map(item => {
                benefitsData.push({
                    benefitId: item.id,
                    groupId: nextProps.compete.benefitsData.body.groupId,
                    projectId: nextProps.compete.benefitsData.body.projectId,
                    benefitName: item.name,
                })
            })
            this.setState({ benefitsData })
        }
        if (nextProps.compete.competitorsGroupsData.Count > 0 && nextProps.compete.competitorsGroupsData.Items[0] && nextProps.compete.competitorsGroupsData.Items[0].competitors && !_.isEmpty(nextProps.compete.competitorsGroupsData.Items[0].competitors) && _.isEmpty(this.state.competitorsGroupsData)) {
            let competitorsGroupsData = [...this.state.competitorsGroupsData]
            nextProps.compete.competitorsGroupsData.Items[0].competitors.map(item => {
                competitorsGroupsData.push({
                    competitorId: item.competitorId,
                    competitorName: item.competitorName,
                    important: item.important,
                    indirect: item.indirect,
                    type: item.type,
                })
            })

            this.setState({ competitorsGroupsData })
        }
        //next step
        if (nextProps.differentialAdvantageData.createDifferentialAdvantageData && nextProps.differentialAdvantageData.createDifferentialAdvantageData.statusCode === 200 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }

    onValueDelete = (data, type, groupId, segmentId) => {
        let advantage = [...this.state.advantage];
        let parentItem = advantage.find(r => r.groupId === groupId && r.segmentId === segmentId);
        let deletedItem = parentItem[type].find(r => r.id === data.id);
        _.remove(parentItem[type], (item) => {
            return (item.id === data.id)
        });

        this.setState({ advantage }, () => { this.saveNewData() })
    }

    saveNewData = () => {
      let body = {
        id: this.props.differentialAdvantageData.getDifferentialAdvantageData.Items[0].id,
        projectId: this.props.projectId,
        type: "advantage",
        advantage: this.state.advantage
      }
      this.props.editDifferentialAdvantage(body);
    }

    onNextButtonClick = () => {
        if (this.state.createdData) {
            let body = {
                projectId: this.props.projectId,
                type: "advantage",
                advantage: this.state.advantage
            }
            this.setState({ goNextStep: true })
            this.props.createDifferentialAdvantage(body)
        }
        if (this.state.editedData) {
            let body = {
                id: this.props.differentialAdvantageData.getDifferentialAdvantageData.Items[0].id,
                projectId: this.props.projectId,
                type: "advantage",
                advantage: this.state.advantage
            }

            this.setState({ goNextStep: true })
            this.props.editDifferentialAdvantage(body);
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Differential Advantage</h5>
                      </div>
                    </div>
                    {/* {!this.props.compete.competeFetching &&  */}
                    {this.props.benefits.benefitsLadderFetched && this.state.competitorsGroupsData.length>0 &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                      <div className="col-md-8">
                                        <div className="criteria-title-box">
                                            <h5>Brainstorm:</h5>
                                            <span>List all of your Similar Tactics, Change of Focus and Change The Rules ideas, hitting the “+” sign after each one</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                        <ImprovingTabs
                                            tabs={this.state.tabs}
                                            competeData={this.state.competeData}
                                            onNewItemAdd={this.onNewItemAdd}
                                            advantage={this.state.advantage}
                                            onValueDelete={this.onValueDelete}
                                            competitorsGroupsData={this.state.competitorsGroupsData}
                                            challengeStatementData={this.props.challengeStatement.getChallengeStatementData}
                                            benefitsData={this.state.benefitsData}
                                            benefits={this.props.benefits}
                                            tabStep={this.props.tabStep}
                                            onTabChange={this.props.onTabChange}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        <a href="/toolkit" className='btn empty-btn default'>Back</a>
                                        {/* <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* } */}

                </div>
            </div>
        )
    }
}

export default (Improving);



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Improving/Improving.jsx